import { isCensoredImage } from '../../../components/CensoredContent';
import { MEDIA_SYNC } from './RecordedMediaExtension';

// Seed real, removable paragraphs only when a placeholder first appears. The
// persisted marker keeps deleted lines deleted through saving and reopening.
export function seedCensoredSpacing(editor, media = []) {
  if (!editor?.state?.doc || editor.isDestroyed || editor.view.composing) return false;
  const rejected = new Set(media.filter(item => item.status === 'rejected').flatMap(item => [item.id, item.localId]));
  const positions = [];
  editor.state.doc.descendants((node, pos) => {
    if (((node.type.name === 'image' && isCensoredImage(node.attrs.src))
      || (node.type.name === 'recordedMedia' && rejected.has(node.attrs.mediaKey))) && !node.attrs.censoredSpaced) positions.push(pos);
  });
  if (!positions.length) return false;
  const tr = editor.state.tr.setMeta(MEDIA_SYNC, true).setMeta('addToHistory', false);
  const paragraph = editor.schema.nodes.paragraph;
  const blank = node => node?.type === paragraph && node.content.size === 0;
  positions.reverse().forEach(pos => {
    const node = tr.doc.nodeAt(pos);
    const at = tr.doc.resolve(pos);
    const inline = node.isInline && at.parent.isTextblock;
    const from = inline ? at.before() : pos;
    const to = inline ? at.after() : pos + node.nodeSize;
    const before = inline && at.parent.content.cut(0, at.parentOffset);
    const after = inline && at.parent.content.cut(at.parentOffset + node.nodeSize);
    const count = (position, direction) => {
      let cursor = position;
      let lines = 0;
      while (lines < 2) {
        const boundary = tr.doc.resolve(cursor);
        const neighbor = direction < 0 ? boundary.nodeBefore : boundary.nodeAfter;
        if (!blank(neighbor)) break;
        lines++; cursor += direction * neighbor.nodeSize;
      }
      return lines;
    };
    const nodes = [];
    if (before?.size) nodes.push(at.parent.copy(before));
    for (let lines = before?.size ? 0 : count(from, -1); lines < 2; lines++) nodes.push(paragraph.create());
    const marked = node.type.create({ ...node.attrs, censoredSpaced: true }, node.content, node.marks);
    nodes.push(inline ? paragraph.create(null, marked) : marked);
    for (let lines = after?.size ? 0 : count(to, 1); lines < 2; lines++) nodes.push(paragraph.create());
    if (after?.size) nodes.push(at.parent.copy(after));
    tr.replaceWith(from, to, nodes);
  });
  editor.view.dispatch(tr);
  return true;
}
